import BotaoOpcoes from './BotaoOpcoes.componente';

export default BotaoOpcoes;
